
import { FutureRelease, FutureReleaseFormData } from '@/types';
import { calculateNextDueDate } from '@/utils/recurrenceCalculations';
import { generateFutureReleaseId } from '@/utils/transactionUtils';

export const createFutureRelease = (
  releaseData: FutureReleaseFormData & { installmentGroupId?: string; installmentNumber?: number; }
): FutureRelease => {
  console.log('[createFutureRelease] Criando lançamento futuro com dados:', releaseData);
  
  // Validar campos obrigatórios
  if (!releaseData.name || !releaseData.name.trim()) {
    throw new Error('Nome do lançamento é obrigatório');
  }
  
  if (!releaseData.amount || releaseData.amount <= 0) {
    throw new Error('Valor deve ser maior que zero');
  }
  
  if (!releaseData.categoryId || !releaseData.categoryId.trim()) {
    throw new Error('Categoria é obrigatória');
  }
  
  if (!releaseData.dueDate) {
    throw new Error('Data de vencimento é obrigatória');
  }
  
  if (!releaseData.type || !['receita', 'despesa'].includes(releaseData.type)) {
    throw new Error('Tipo deve ser receita ou despesa');
  }

  // Only set paidDate if it is present and a string
  let paidDate: string | undefined = undefined;
  if ("paidDate" in releaseData && typeof (releaseData as any).paidDate === "string") {
    paidDate = (releaseData as any).paidDate;
  }

  // RESPEITAR status fornecido; default para 'agendado'
  const status = (releaseData as any).status || 'agendado';

  // Gerar UUID válido - especialmente importante para parcelas do mesmo grupo
  let uniqueId: string;
  if (releaseData.installmentGroupId && releaseData.installmentNumber) {
    // Para parcelas, usar UUID base + sufixo para manter unicidade
    const baseId = generateFutureReleaseId();
    uniqueId = `${baseId}`;
  } else {
    // Para releases avulsas, usar UUID padrão
    uniqueId = generateFutureReleaseId();
  }

  const newRelease: FutureRelease = {
    id: uniqueId,
    name: releaseData.name.trim(),
    amount: Number(releaseData.amount) || 0,
    categoryId: releaseData.categoryId,
    dueDate: releaseData.dueDate,
    description: releaseData.description || '',
    status, // <-- status respeitado
    isRecurrent: Boolean(releaseData.isRecurrent),
    recurrence: releaseData.recurrence || 'unica',
    recurrenceEndDate: releaseData.recurrenceEndDate,
    type: releaseData.type,
    paymentMethod: releaseData.paymentMethod || 'pix',
    createdAt: new Date().toISOString(),
    ...(releaseData.installmentGroupId ? { installmentGroupId: releaseData.installmentGroupId } : {}),
    ...(typeof releaseData.installmentNumber === "number" ? { installmentNumber: releaseData.installmentNumber } : {}),
    ...(paidDate ? { paidDate } : {}),
    ...(releaseData.accountId ? { accountId: releaseData.accountId } : {}),
    ...(releaseData.cardId ? { cardId: releaseData.cardId } : {}),
  };

  console.log('[createFutureRelease] Lançamento criado com UUID válido:', newRelease);
  return newRelease;
};

export const updateFutureReleaseData = (
  releases: FutureRelease[],
  id: string,
  updatedData: Partial<FutureRelease> & { paidDate?: string; lastProcessedDate?: string }
): FutureRelease[] => {
  console.log(`[updateFutureReleaseData] Atualizando release específica com ID: ${id}`, updatedData);
  
  return releases.map(release => {
    if (release.id === id) {
      console.log(`[updateFutureReleaseData] ✅ Atualizando release ${id} de ${release.status} para ${updatedData.status}`);
      return { 
        ...release, 
        ...updatedData,
        amount: Number(updatedData.amount ?? release.amount) || 0,
        paidDate: updatedData.paidDate ?? release.paidDate,
        ...(updatedData.lastProcessedDate && { lastProcessedDate: updatedData.lastProcessedDate }),
      };
    }
    return release;
  });
};
